import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getDriverLedger
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { fetchSingleDriver, driverSettleAmount, deleteSingleDriverTransaction, fetchSingleDriverTransaction, driverAdditionType, driverDeductionType, addReduceDriverTransaction } from '../../../store/actions/vehicleActionCreator';
import { getDateInStringDocumentDDMMMYYYY } from '../../../utils/utils';
import { Dialog } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import NotesIcon from '@material-ui/icons/Notes';
import DateFnsUtils from '@date-io/date-fns';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import DriverGaveAndGot from '../../components/DriverDialogs/DriverGaveAndGot';
import DialogActions from '@material-ui/core/DialogActions';
import InfoDialog from '../../components/Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize } from '../../../paginationVariables';
import { PaperPlaneIconWhite } from '../../../components/icons';
import queryString from "query-string";
import { getPaymentStatus,getSinglePayment } from '../../../store/actions/OnlinePaymentActionCreators';
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import PayDriverSideBar from '../../components/RightSideBar/PayDriverSideBar';
import PaymentDetailsSideBar from '../../components/DriverDialogs/PaymentDetailsSideBar/PaymentDetailsSideBar';
import { PendingIconOrange } from '../../../components/icons';
import { trackDwebEvent } from '../../analytics';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';
import {GetPaymentStatusIconOnly,GetPaymentModes} from '../../components/Payment/GetPaymentStatusIcon';
import SingleOnlineTransactionDetailsCard from '../../components/Payment/SingleOnlineTransactionDetailsCard'
import TransactionDetailsSideBar from '../../components/RightSideBar/TransactionDetailsSideBar';
import DottedDivider from '../../components/Divider/DottedDivider';
import TripListingCard from '../../components/listing/TripListingCard';
const SingleDriver = ({ 
    dispatchGetPaymentDetails,
    dispatchDeleteSingleTransaction, 
    dispatchGetDriverDeductionTypes, 
    dispatchGetDriverAdditionTypes, 
    dispatchFetchSingleDriverTransaction, 
    dispatchGetSingleDriver, vehicle, user, 
    dispatchSettleDriverAmount, 
    dispatchGetPaymentStatus 
}) => {

    let submit;
    let history = useHistory();
    const queryParams = new URLSearchParams(window.location.search)

    const [singleDriverData, setSingleDriverData] = useState({});
    const [settleModalOpen, setSettleModalOpen] = useState(false);
    const [driverGaveGotDialog, setDriverGaveGotDialog] = useState(false);
    const [recall, setRecall] = useState(false);
    const [type, setType] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [infoOpen, setInfoOpen] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [driverPaymentOpen, setDriverPaymentOpen] = useState(false);
    const [defaultData, setDefaultData] = useState(null);
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
    const [transactionDetailsOnlineOpen, setTransactionDetailsOnlineOpen] = useState(false);
    const [selectedRowInfo, setSelectedRowInfo] = useState({});
    const [payoutData, setPayoutData] = useState({});
    const [configInfo, setConfigInfo] = useState({});
    const [pdfOpen, setPdfOpen] = useState(false);


    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let driverIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];

    const classes = useStyles();

    useEffect(() => {
        fetchSingleDriverDetails()
    }, [recall]);
    const getPaginatedData = () => {
        fetchSingleDriverDetails(true)
    }
    const fetchSingleDriverDetails = (pagination) => {
        var data = {
            pageNo: defaultPageNo,
            pageSize: defaultPageSize
        }
        if (pagination) {
            data = {
                ...data,
                pageNo: currentPageNo + 1,
                pageSize: currentPageSize,
                merge: true
            }
        }
        dispatchGetSingleDriver(driverIdValue, data,
            (driverData) => {
                logger.log("singleDriverComponent", "Single Driver Fetch Successfull");
                let info = driverData&&driverData.response?driverData.response:null
                if (orderId) {
                    dispatchGetPaymentStatus({
                        orderId: orderId
                    }, (response) => {
                        if (response && response.status && response.status.code == 200) {
                            setDriverPaymentOpen(false);
                            if (response.response.message == "Transaction Failed.") {
                                handleFailureOpen();
                                setTimeout(() => {
                                    handleFailureClose(info)
                                }, 3000);
                            } else {
                                handleSuccessOpen();
                                setTimeout(() => {
                                    handleSuccessClose(info)
                                }, 3000);
                            }
                        } else {
                            handleFailureOpen();
                            setTimeout(() => {
                                handleFailureClose(info)
                            }, 3000);
                        }
                    }, (response) => {
                        handleFailureOpen();
                        setTimeout(() => {
                            handleFailureClose(info);
                        }, 3000);
                    })
                }
            },
            () => {
                logger.log("singleDriverComponent", "Single Driver Fetch Failed");
            }
        )
    }
    useEffect(() => {
        if (vehicle && vehicle.singleDriverData) {
            setSingleDriverData(vehicle.singleDriverData);
        }
    }, [vehicle.singleDriverData]);

    useEffect(() => {
        dispatchGetDriverDeductionTypes(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    dispatchGetDriverAdditionTypes(
                        () => {
                        },
                        () => {
                        }
                    );
                }
            },
            () => {
            }
        );

    }, []);

    useEffect(() => {

        

    }, [
        dispatchGetSingleDriver, orderId
    ]);

    useEffect(() => {

        if (user && user.configs && user.configs.online_payments_config) {
            setConfigInfo(user.configs.online_payments_config);
        } else {
            setConfigInfo({});
        }
    }, [user.configs]);
    const muiData = singleDriverData.transactions;
    const muiColumns = [
        {
            name: "transactionDate",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (vehicle && vehicle.singleDriverData && vehicle.singleDriverData.maxPage && vehicle.singleDriverData.maxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <span>{getDateInStringDocumentDDMMMYYYY(value)}</span>
                            </Fragment>
                        );
                    } else {
                        return <span>{getDateInStringDocumentDDMMMYYYY(value)}</span>
                    }
                }
            },
        },
        {
            name: "displayName",
            label: "Reason",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const detailsInfo = singleDriverData && singleDriverData.transactions && singleDriverData.transactions[dataIndex] ? singleDriverData.transactions[dataIndex] : {}
                    return (
                        <div style={{ display: 'flex',alignItems:'center' }}>
                            <div className={classes.fw300}>{detailsInfo && detailsInfo.displayName ? detailsInfo.displayName : ""}</div>
                            {detailsInfo && detailsInfo.tripInfo && detailsInfo.tripInfo.id &&
                                <div style={{ fontWeight: 300, marginLeft: 16, borderRadius: '4px', color: 'white', backgroundColor: '#e86825', fontSize: 11, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8 }}>From a trip</div>
                            }
                            {detailsInfo && !detailsInfo.tripInfo && detailsInfo.vehicleInfo && detailsInfo.vehicleInfo.id &&
                                <div style={{ fontWeight: 300, marginLeft: 16, borderRadius: '4px', color: 'white', backgroundColor: '#e86825', fontSize: 11, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8 }}>From a truck</div>
                            }
                            {detailsInfo && detailsInfo.is_broker_enabled &&
                                <>
                                    {detailsInfo && detailsInfo.paymentStatus &&
                                        <div className={classes.divAlignV1}>
                                            <GetPaymentStatusIconOnly type={detailsInfo.paymentStatus} />
                                            <div className={classes.divTranstNoV1}>{singleDriverData.transactions && singleDriverData.transactions[dataIndex] && singleDriverData.transactions[dataIndex].paymentData ? singleDriverData.transactions[dataIndex].paymentData : ""}</div>
                                        </div>
                                    }
                                </>
                            }
                        </div >
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Driver Gave",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.fw300}>{value < 0 ? numberFormat(Number(value)) : ""}</div>
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Driver Got",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.fw300}>{value > 0 ? numberFormat(Number(value)) : ""}</div>
                    )
                }
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            {singleDriverData.transactions && singleDriverData.transactions[dataIndex] && !singleDriverData.transactions[dataIndex].is_broker_enabled &&
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid #0033cc', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px' }} onClick={() => handleSingleDriverRow(dataIndex)} ><EditIcon style={{ color: '#0033cc', fontSize: '16px' }} /></IconButton>
                                    </div>
                                    <div>
                                        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid red', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px', marginLeft: '16px' }} onClick={() => handleDeleteDialogOpen(dataIndex)} ><DeleteIcon style={{ color: 'red', fontSize: '16px' }} /></IconButton>
                                    </div>
                                </div>
                            }
                        </>
                    )
                }
            },
        },

    ];
    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search Drivers',
        onCellClick: (colData, cellMeta) => {

            const seletedRow = muiData && muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] ? muiData[cellMeta && cellMeta.dataIndex ? cellMeta.dataIndex : 0] : {}

            let colIndexValue;

            if (seletedRow.is_broker_enabled) {
                colIndexValue = 5
            } else {
                colIndexValue = 4
            }

            if (cellMeta.colIndex != colIndexValue) {
                handleTransactionDetail(seletedRow);
            }
        },
        textLabels: {
            body: {
                noMatch: "No Payments are Available",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleSettleAmountOpen = () => {
        setSettleModalOpen(true);
    }

    const handleClose = () => {
        setSettleModalOpen(false);
    }

    const handleConfirm = () => {
        setDriverGaveGotDialog(false);
        setRecall(!recall);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const handleDeleteDialogOpen = (index) => {
        const transactionId = singleDriverData.transactions[index].id;
        setTransactionId(transactionId);
        setDeleteDialog(true);
    }

    const onDeleteTransaction = () => {
        dispatchDeleteSingleTransaction(transactionId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single driver Component Dweb", "Delete transaction successfull");
                    setDeleteDialog(false);
                    setRecall(!recall);
                }
            },
            () => {
                logger.log("Single driver Component Dweb", "Delete transaction failed");
            }
        );
    }

    const handleSingleDriverRow = (index) => {
        const transactionId = singleDriverData.transactions[index].id;
        const amount = singleDriverData.transactions[index].amount;
        if(transactionId){
            dispatchFetchSingleDriverTransaction(transactionId,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Single Driver Compoennet Dweb", 'SuccessFull, Single transaction ');
                        if (amount < 0) {
                            setType("driverGave");
    
                            // dispatchGetDriverDeductionTypes(
                            //     () => {
                            //     },
                            //     () => {
                            //     }
                            // );
                        } else {
                            setType("driverGot");
    
                            // dispatchGetDriverAdditionTypes(
                            //     () => {
                            //     },
                            //     () => {
                            //     }
                            // );
                        }
                        setDriverGaveGotDialog(true);
                    }
                },
                () => {
                    logger.log("Single Driver Compoennet Dweb", 'Failed, Single transaction ');
                }
            );
        }
    }

    const handleTransactionDetail = (selectedRow) => {
        if(selectedRow){
            setSelectedRowInfo(selectedRow);
            if(selectedRow.id && selectedRow.is_broker_enabled){
                let req ={
                    transactionId:selectedRow.id,
                    entityType:'driver',
                    entityId:driverIdValue
                }
                dispatchGetPaymentDetails(
                    req,
                    (response) => {
                        if (response && response.status && response.status.code == 200 && response.response) {
                            setSelectedRowInfo(response.response);
                            setTransactionDetailsOnlineOpen(true);
                        }
                    },
                    (response) => {

                    }
                )
            }else{
                setTransactionDetailsOpen(true);
            }
        }
    }

    const handleBalanceClose = () => {
        setDriverGaveGotDialog(false);
    }

    const onSubmit = values => {

        var data = {
            driverId: driverIdValue,
            amount: singleDriverData.totalBalance,
            transactionDate: Math.round(values.date.setHours(0, 0, 0, 0) / 1000),
            description: values.note
        }


        dispatchSettleDriverAmount(data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Sinlge Driver Component Dweb", 'Successfull');
                    setRecall(!recall);
                    setSettleModalOpen(false);
                }
            },
            () => {
                logger.log("Sinlge Driver Component Dweb", 'Failed');
            }
        );

    }

    const validate = values => {
        const errors = {};

        if (!values.date) {
            errors.date = "Please enter date"
        }

        return errors;
    }

    const handleInfoClick = () => {
        setInfoOpen(true);
    }

    const handleInfoClose = () => {
        setInfoOpen(false);
    }

    const handleSendMoney = (amount) => {
        setDriverPaymentOpen(true);
        setDefaultData({
            id: driverIdValue,
            ...vehicle.singleDriverData,
            amount:amount?amount:null
        });

        const driverInfo = vehicle && vehicle.singleDriverData ? vehicle.singleDriverData : {}

        trackDwebEvent('Dweb Single Driver Page Driver payout initiated', {
            driver_id: driverIdValue ? driverIdValue : "",
            driver_name: driverInfo && driverInfo.name ? driverInfo.name : "",
            driver_balance: driverInfo && driverInfo.totalBalance ? driverInfo.totalBalance : 0
        });
    }

    const handlePayDriverClose = (entityData) => {
        setDefaultData(null);
        setDriverPaymentOpen(false);
        setPayoutData(entityData);
    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)

        const driverInfo = vehicle && vehicle.singleDriverData ? vehicle.singleDriverData : {};

        trackDwebEvent('Dweb Driver payout successful', {
            driver_id: driverIdValue ? driverIdValue : "",
            driver_name: driverInfo && driverInfo.name ? driverInfo.name : "",
            driver_balance: driverInfo && driverInfo.totalBalance ? driverInfo.totalBalance : 0,
            driver_payout_amount: payoutData && payoutData.payments && payoutData.payments[0] && payoutData.payments[0].amount ? payoutData.payments[0].amount : "",
            driver_payout_reason: payoutData && payoutData.description ? payoutData.description : "",
            bank_account_id: payoutData && payoutData.bankId ? payoutData.bankId : ""
        })
    }

    const handleSuccessClose = (info) => {
        setSuccessCreation(false)
        goToDriverView(info)
        //setRecall(!recall);
    }

    const handleFailureOpen = () => {
        setFailureCreation(true);

        const driverInfo = vehicle && vehicle.singleDriverData ? vehicle.singleDriverData : {};

        trackDwebEvent('Dweb Driver payout failed', {
            driver_id: driverIdValue ? driverIdValue : "",
            driver_name: driverInfo && driverInfo.name ? driverInfo.name : "",
            driver_balance: driverInfo && driverInfo.totalBalance ? driverInfo.totalBalance : 0,
            driver_payout_amount: payoutData && payoutData.payments && payoutData.payments[0] && payoutData.payments[0].amount ? payoutData.payments[0].amount : "",
            driver_payout_reason: payoutData && payoutData.description ? payoutData.description : "",
            bank_account_id: payoutData && payoutData.bankId ? payoutData.bankId : ""
        })
    }
    const goToDriverView = (driverInfo) => {
            const driverId = driverIdValue;
            const driverName = driverInfo && driverInfo.name?driverInfo.name:'';
            const status = driverInfo && driverInfo.status?driverInfo.status:'';

            history.push({
                pathname: `/drivers/single-driver/${driverId}`,
                state: {
                    id: 8,
                    driverStatus: status || null,
                    pageTitle: driverName ? driverName : 'Driver View',
                    driverId: driverId
                }
            });
    }

    const handleFailureClose = (info) => {
        setFailureCreation(false)
        goToDriverView(info)
        //setRecall(!recall);
    }

    const handlePaymentDetailsClose = () => {
        setTransactionDetailsOpen(false);
    }
    const handleOnlinePaymentDetailsClose = () => {
        setSelectedRowInfo(null)
        setTransactionDetailsOnlineOpen(false);
    }
    const handlePayAgain = () => {
        setTransactionDetailsOnlineOpen(false);
        handleSendMoney(selectedRowInfo&&selectedRowInfo.amount?selectedRowInfo.amount:null);
        setSelectedRowInfo(null)
    }

    const handleTransactDelete = () => {
        setTransactionDetailsOpen(false);
        setRecall(!recall);
    }

    const handleViewPdf = () => {
        setPdfOpen(true);
    }

    const handlePdfClose = () => {
        setPdfOpen(false);
    }

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDIv} elevation={3}>
                    <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
                        <Grid item>
                            <Paper className={classes.infoCard1} >
                                <div className={classes.divV2}>
                                    <div className={classes.divV3}>
                                        <Typography variant="subtitle2" className={classes.infoCardTitle1}>
                                            {singleDriverData.balanceText}{singleDriverData.balanceText == "Total Balance" && <span> <InfoOutlinedIcon className={classes.infoV1} onClick={handleInfoClick} /></span>}
                                        </Typography>
                                        <Typography variant="subtitle2" className={classes.balanceV1}>
                                            {singleDriverData.totalBalance == 0 &&
                                                <span style={{ color: 'black' }}>
                                                    {numberFormat(singleDriverData.totalBalance)}
                                                </span>
                                            }
                                            {singleDriverData.totalBalance != 0 &&
                                                <div className={singleDriverData.totalBalance > 0 ? [classes.profit] : [classes.loss]}>{numberFormat(singleDriverData.totalBalance)}</div>
                                            }
                                        </Typography>
                                    </div>
                                    <div className={classes.divAlignV3}>
                                        {((singleDriverData.totalBalance * -1) > 0 || singleDriverData.totalBalance > 0) &&
                                            <div>
                                                <Button variant="outlined" className={classes.button1} onClick={() => handleSettleAmountOpen()}>
                                                    <span className={classes.mrV1}>&#8377;</span>
                                                    <span>Settle Amount</span>
                                                </Button>
                                            </div>
                                        }
                                        {/* {configInfo && configInfo.driverPayout && configInfo.driverPayout.show == 1 &&
                                            <Button variant="contained" className={classes.singleDriverSendMoney} onClick={() => handleSendMoney()}>
                                                <div className={classes.divAlignV4}>
                                                    <PaperPlaneIconWhite />
                                                    <div className={classes.mlV5}>&nbsp;Send Money</div>
                                                </div>
                                            </Button>
                                        } */}

                                        <Button variant="contained" className={classes.singleDriverPdfButton} onClick={() => { handleViewPdf() }}>
                                            <PictureAsPdfIcon />&nbsp;View PDF
                                        </Button>

                                        {/* style={{ display: 'flex', alignItems: 'center' }} */}
                                    </div>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                    <div className={classes.dividerDiv}></div>
                    <div className={classes.driverTable}>
                        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                    </div>
                </Paper>

                {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={"Total Balance"} confirmMessage={"The total amount to be collected or paid to this driver"} onClose={handleInfoClose} />}

                {/* Settle Amount Dialog. */}
                <Dialog fullWidth={true}
                    maxWidth='xs'
                    onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={settleModalOpen}>
                    <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            < div > Settle Amount </div>
                            <div>
                                <IconButton onClick={() => handleClose()}>
                                    <CloseIcon style={{ color: '#D8D8D8' }} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={{ date: new Date() }}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    < form onSubmit={(event) => {
                                        const promise = handleSubmit(event);
                                        // promise && promise.then(() => {
                                        //     form.reset();
                                        // })
                                        return promise;
                                    }} id="myForm" noValidate>
                                        {/* <div className={classes.divAmount} >Amount To be Settled</div> */}
                                        <div className={classes.divV14}>
                                            <div className={classes.divAmount}>
                                                Amount to be settled
                                            </div>
                                            <div className={classes.amountV1}>
                                                {numberFormat(singleDriverData.totalBalance)}
                                            </div>
                                        </div>

                                        <div className={classes.divDate}>Date</div>
                                        <DatePicker
                                            disableFuture
                                            name="date"
                                            variant="inline"
                                            inputVariant="outlined"
                                            size="small"
                                            format="dd-MM-yyyy"
                                            // label="Date"
                                            placeholder="Select Date"
                                            dateFunsUtils={DateFnsUtils}
                                            className={classes.marginV1}
                                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                        />

                                        <div style={{ color: '#9ea0a5', fontSize: 12, fontWeight: 500, marginTop: 18 }}>Notes</div>
                                        <TextField
                                            // label="Note"
                                            placeholder="Notes"
                                            name="note"
                                            margin="none"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>,
                                            }}
                                            helperText={"Optional"}
                                            className={classes.marginV1}
                                        />

                                        <Divider className={classes.mtV1} />

                                    </form>

                                )
                            }}
                        />

                        <div className={classes.divV7}>
                            <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                                Close
                            </Button>
                            <Button className={classes.confirmV1} type="submit" variant="contained"
                                onClick={event => {
                                    submit(event)
                                }}
                            >
                                Confirm
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                {/* Delete transaction dialog. */}
                <Dialog
                    fullWidth={true}
                    maxWidth='xs'
                    disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteDialog} onClose={handleDeleteDialogClose}
                >
                    <DialogContent>
                        <div className={classes.divV25}> Delete Transaction</div>
                        <div className={classes.mtV5}>Are you sure you want to delete</div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteDialogClose}>
                            <span className={classes.cancelV1}>
                                CANCEL
                            </span>
                        </Button>
                        <Button onClick={onDeleteTransaction}>
                            <span className={classes.deleteV1}>
                                DELETE
                            </span>
                        </Button>
                    </DialogActions>
                </Dialog>

            </Wrapper>

            {driverGaveGotDialog && <DriverGaveAndGot balanceType={type} onClose={handleBalanceClose} onOpen={driverGaveGotDialog} driverId={driverIdValue ? driverIdValue : ""} onEdit={true} onConfirm={handleConfirm} />}
            {driverPaymentOpen && <PayDriverSideBar
                rightSideBarOpen={driverPaymentOpen}
                defaultData={defaultData}
                sideBarTitle={'Driver Payment'}
                handleSubmit={event => { }}
                toggleRightSideBar={handlePayDriverClose}
                fromSingleDriver={true}
            ><div></div></PayDriverSideBar>}
            {transactionDetailsOnlineOpen && <TransactionDetailsSideBar
                    rightSideBarOpen={transactionDetailsOnlineOpen}
                    sideBarTitle={'Transaction Details'}
                    sideBarSecondaryTitle={null}
                    handleSubmit={event => { }}
                    transData={selectedRowInfo}
                    payAgain={handlePayAgain}
                    toggleRightSideBar={handleOnlinePaymentDetailsClose}
                >
                    <div id="payment-details-card">
                        <SingleOnlineTransactionDetailsCard
                            data={selectedRowInfo}
                        />
                        {(selectedRowInfo && (selectedRowInfo.tripDetails && selectedRowInfo.tripDetails.length > 0 || selectedRowInfo.tripId)) && <><DottedDivider />
                            <TripListingCard
                                data={selectedRowInfo}
                                type={selectedRowInfo && selectedRowInfo.entityType ? selectedRowInfo.entityType : null}
                            /></>}
                    </div>
            </TransactionDetailsSideBar>}
            {successCreation && <SuccessDialog open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {transactionDetailsOpen && <PaymentDetailsSideBar rightSideBarOpen={transactionDetailsOpen} onClose={handlePaymentDetailsClose} selectedRow={selectedRowInfo} onDelete={handleTransactDelete} />}
            {pdfOpen &&
                <ReportsDialog open={pdfOpen} name={"Driver Khata"} fromSingleDriverPage={true} driverIdFromSingleDriver={driverIdValue ? driverIdValue : ""} onClose={handlePdfClose} />
            }
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleDriver: (id, data, onSuccess, onFailure) => {
        dispatch(fetchSingleDriver(id, data, onSuccess, onFailure));
    },
    dispatchSettleDriverAmount: (data, onSuccess, onFailure) => {
        dispatch(driverSettleAmount(data, onSuccess, onFailure));
    },
    dispatchFetchSingleDriverTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchGetDriverDeductionTypes: (onSuccess, onFailure) => {
        dispatch(driverDeductionType(onSuccess, onFailure));
    },
    dispatchGetDriverAdditionTypes: (onSuccess, onFailure) => {
        dispatch(driverAdditionType(onSuccess, onFailure))
    },
    dispatchDeleteSingleTransaction: (id, onSuccess, onFailure) => {
        dispatch(deleteSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchGetPaymentDetails: (data, onSuccess, onError) => {
        dispatch(getSinglePayment(data, onSuccess, onError))
    },
})

const SingleDriverWithRouter = withRouter(SingleDriver);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SingleDriverWithRouter);